module.exports = __webpack_public_path__ + "static/media/calculator.87c33a9b.svg";